/*
 * @Author: liyifan 
 * @Date: 2025-08-13 10:18:22 
 * @Last Modified by: liyifan
 * @Last Modified time: 2025-08-13 10:18:44
 * @description: 拦截购买流程
 */
class InterceptPurchaseProcess {
  constructor() {
    this.getFullGiftList()
    this.init();
  }
  // 获取所有的满赠商品
  async getFullGiftList() {
    window.fullGiftList = []
    try {
      const { api, shopId, } = window.pageInfo
      const url = `${api}/osconsumerapi/metafields/auto-buy-free?shopifyShopId=${shopId || ''}`
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json",
        },
      });
      const { data, } = await response.json();
      window.fullGiftList = data
    } catch (error) {
      console.log(error)
    }
  }
  // 更改cart/add.js请求
  init() {
    const originalFetch = window.fetch;
    window.fetch = async function(url, options) {
      if (url.includes('/cart/add.js')) {
        let params = JSON.parse(options?.body || '{}')
        // 判断所加商品是否具有赠品
        let items = params.items || [];
        if (!items.length) {
          items = [params]
        }
        const fullItems = items.flatMap(item => {
          const giftList = window.fullGiftList.find(item1 => item.id == item1.id)?.autoBuyChildResps || [];
          return giftList ? giftList.map(giftItem => ({
            id: giftItem.id,
            quantity: Number(giftItem.quantity) * Number(item.quantity),
            properties: {
            }
          })) : [];
        });
        
        if (fullItems.length) {
          params = {
            items: [...items, ...fullItems]
          };
        }
        options.body = JSON.stringify(params)
      }
      return originalFetch.call(window, url, options)
    };
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new InterceptPurchaseProcess()
})
